// extracted by mini-css-extract-plugin
export var numpadContainer = "_no-1";
export var phoneButton = "_no-0";